import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { NotificationsAlertsService } from '@notifications/infra';
import { UpdateNearbyGamesAlertsBody } from '@core-http';
import { UpdateAlertsSettingsCommandPayload } from './update-alerts-settings.command-payload';

export class UpdateAlertsSettingsCommandHandler {
  private notificationsAlertsService: NotificationsAlertsService = inject(NotificationsAlertsService);

  switchAlerts(value: boolean): Observable<void> {
    return this.notificationsAlertsService.switchAlerts(value);
  }

  updateAlertsSettings(payload: UpdateAlertsSettingsCommandPayload): Observable<void> {
    const body: UpdateNearbyGamesAlertsBody = {
      isEnabled: payload.isEnabled,
      coordinates: payload.coordinates ?? null,
      maxDistanceMeters: payload.maxDistanceMeters,
      time: payload.time,
      gameLevel: payload.gameLevel,
      specificWeekdays: payload.specificWeekdays
    };

    return this.notificationsAlertsService.updateAlerts(body);
  }
}
